import { render, staticRenderFns } from "./settings-expand.vue?vue&type=template&id=f9adba50&scoped=true&"
import script from "./settings-expand.vue?vue&type=script&lang=js&"
export * from "./settings-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9adba50",
  null
  
)

export default component.exports